import { render, staticRenderFns } from "./_MediaGroupMediaWrapper.vue?vue&type=template&id=0cde5aea&scoped=true&"
import script from "./_MediaGroupMediaWrapper.vue?vue&type=script&lang=js&"
export * from "./_MediaGroupMediaWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cde5aea",
  null
  
)

export default component.exports